import { Component } from '@angular/core';
import { formatTime } from 'app/core/shared/helper/time.helper';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup } from '@angular/forms';
import { handleFormatDate } from 'app/core/shared/helper/date.helper';
import { AprService } from 'app/modules/annulus-pressure-record/services/annulus-pressure-record.service';
import { ActivatedRoute, Router } from '@angular/router';
import module from "app/modules/annulus-pressure-record/annulus-pressure-record.module";

@Component({
  selector: 'app-apr-pi-view',
  templateUrl: './apr-pi-view.component.html',
  standalone: true,
  imports: module,
  styleUrls: ['./apr-pi-view.component.scss']
})
export class AprPiViewPage {
  public aprForm: FormGroup
  public initialFormValues: any;

  public aprPiRecord: any
  private piId = this.route.snapshot.paramMap.get('id');

  ngOnInit() {
    this.aprForm = this.initializeForm()
    this.getAprPi()
  }

  constructor(
    private fb: FormBuilder,
    public location: Location,
    private aprService: AprService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }


  initializeForm() {
    return this.fb.group({
      id: this.piId,
      fieldShortName: '',
      fieldLongName: '',
      platformShortName: '',
      platformLongName: '',
      wellShortName: [{ value: '', disabled: true }],
      wellLongName: [{ value: '', disabled: true }],
      wellStringId: [{ value: '', disabled: true }],
      stringShortName: [{ value: '', disabled: true }],
      stringLongName: [{ value: '', disabled: true }],
      stringIndicatorShortName: [{ value: '', disabled: true }],
      prodStatus: '',
      activity: [{ value: '', disabled: true }],
      thp: [{ value: '', disabled: true }],
      annAPress: [{ value: '', disabled: true }],
      remarks: [{ value: '', disabled: true }],
      recordDate: [{ value: new Date().toISOString(), disabled: true }],
      recordTime: [{ value: formatTime(new Date), disabled: true }],
      inputBy: '',
      inputDate: new Date().toISOString(),
      isScanOffPcp: false,
      isScanOffThp: false,
      prodStatusInputDate: new Date().toISOString(),
    })
  }

  private getAprPi() {
    this.aprService.getAprPiRecordById(this.piId).subscribe((res) => {
      if (res) {
        this.aprPiRecord = res.data

        this.aprForm.patchValue({
          id: this.piId,
          fieldShortName: this.aprPiRecord.fieldShortName,
          fieldLongName: this.aprPiRecord.fieldLongName,
          platformShortName: this.aprPiRecord.platformShortName,
          platformLongName: this.aprPiRecord.platformLongName,
          wellShortName: this.aprPiRecord.wellShortName,
          wellLongName: this.aprPiRecord.wellLongName,
          wellStringId: this.aprPiRecord.wellStringId,
          stringShortName: this.aprPiRecord.stringShortName,
          stringLongName: this.aprPiRecord.stringLongName,
          stringIndicatorShortName: this.aprPiRecord.stringIndicatorShortName,
          prodStatus: this.aprPiRecord.prodStatus,
          activity: this.aprPiRecord.activity,
          thp: this.handleThpPhpValue(this.aprPiRecord.thp,this.aprPiRecord.isScanOffThp),
          annAPress: this.handleThpPhpValue(this.aprPiRecord.thp,this.aprPiRecord.isScanOffPcp),
          remarks: this.aprPiRecord.remarks,
          recordDate: this.aprPiRecord.recordDate,
          recordTime: this.getTime(this.aprPiRecord.recordDate),
          inputBy: this.aprPiRecord.inputBy,
          inputDate: this.aprPiRecord.inputDate,
          isScanOffPcp: this.aprPiRecord.isScanOffPcp,
          isScanOffThp: this.aprPiRecord.isScanOffThp,
          prodStatusInputDate: this.aprPiRecord.prodStatusInputDate,
        })

        this.initialFormValues = { ...this.aprForm.getRawValue() }
      }
    })
  }

  getTime(recordDate) {
    let date = new Date(recordDate)
    return formatTime(date)
  }

  handleThpPhpValue(value : any, isScanOff: any  ){
    if(!value) {
      if(isScanOff){
        return 'Scan Off'
      } else {
        return 'N/A'
      }
    } 

    return value.toFixed(0);  
  }
  
  // Method to check if the form values have changed
  hasFormChanged(): boolean {
    return JSON.stringify(this.initialFormValues) !== JSON.stringify(this.aprForm.getRawValue());
  }

  handleDate(date) {
    return handleFormatDate(date, true)
  }

  back(){
    this.router.navigate(
      [`/data-management/annulus-pressure-record/`],
      { queryParams: { tab : this.aprPiRecord.activity } }
    );
  }

}
